import Api from 'utils/api'

type PK = string | number

interface PaginationParams {
  limit?: number
  offset?: number
  ordering?: string[]
  search?: string
}

export const fetchUsers = ({ limit, department, offset, ordering, search }: PaginationParams & { department?: PK }) =>
  Api.get(['users'], { limit, department, offset, ordering, search })

export const fetchUserDepartments = (
  departmentId: PK,
  { limit, offset, ordering }: Omit<PaginationParams, 'search'>,
) =>
  Api.get([`users/${departmentId}/departments`], {
    limit,
    offset,
    ordering,
  })

export const fetchUserDepartmentProjects = (
  departmentId: PK,
  projectId: PK,
  { limit, offset, ordering, search }: PaginationParams,
) =>
  Api.get([`users/${departmentId}/departments/${projectId}/projects`], {
    limit,
    offset,
    ordering,
    search,
  })

// edit, delete, add & invite user

export const postUser = (payload: Record<string, unknown>) => Api.post(['users'], payload)

export const patchUser = (pk: PK, payload: Record<string, unknown>) => Api.patch(['users', pk], payload)

export const deleteUser = (pk: PK) => Api.delete(['users', pk])

export const inviteUser = (pk: PK) => Api.post(['users', pk, 'send-credentials'])

// edit access to a single department

export const postUserDepartment = ({ pk, departmentId }: { pk: PK; departmentId: PK }) =>
  Api.post(['users', pk, 'departments'], { id: departmentId })

export const deleteUserDepartment = ({ pk, departmentId }: { pk: PK; departmentId: PK }) =>
  Api.delete(['users', pk, 'departments', departmentId])

// edit access to a single project

export const postProjectAccess = ({ pk, departmentId, projectId }: { pk: PK; departmentId: PK; projectId: PK }) =>
  Api.post(['users', pk, 'departments', departmentId, 'projects'], {
    id: projectId,
  })

export const deleteProjectAccess = ({ pk, departmentId, projectId }: { pk: PK; departmentId: PK; projectId: PK }) =>
  Api.delete(['users', pk, 'departments', departmentId, 'projects', projectId])

// edit access to multiple projects at once

export const postDepartmentProjectsAccess = ({ pk, departmentId }: { pk: PK; departmentId: PK }) =>
  Api.post(['users', pk, 'departments', departmentId, 'projects'])

export const deleteDepartmentProjectsAccess = ({ pk, departmentId }: { pk: PK; departmentId: PK }) =>
  Api.delete(['users', pk, 'departments', departmentId], {
    only_project_access: 1,
  })

// check if user has access to all projects in department

export const fetchAllProjectsAccess = ({ pk, departmentId }: { pk: PK; departmentId: PK }) =>
  Api.get(['users', pk, 'departments', departmentId])
